import { render, staticRenderFns } from "./TabFotos.vue?vue&type=template&id=02333d26&scoped=true"
import script from "./TabFotos.vue?vue&type=script&lang=js"
export * from "./TabFotos.vue?vue&type=script&lang=js"
import style0 from "./TabFotos.vue?vue&type=style&index=0&id=02333d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02333d26",
  null
  
)

export default component.exports